import * as React from "react";
import { Center, Stack, Loader, Text } from "@mantine/core";

interface LoadingScreenProps {
    message?: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({
    message = "Loading...",
}) => {
    return (
        <Center style={{ height: "100%", minHeight: "400px", width: "100%" }}>
            <Stack align="center" gap="md">
                <Loader size="xl" variant="bars" />
                <Text size="lg" fw={500} c="dimmed">
                    {message}
                </Text>
            </Stack>
        </Center>
    );
};
